import type { ShapeData } from '@/lib/shapes/types/shape-data'
import { resolvePlacedClikArtId } from '@/lib/clikart/sync-clikart-placement-from-shapes'

/**
 * True for a ClikArt that is its own object: the borderless, transparent kindId 1 rectangle a
 * tray drop creates (`buildPlacedClikArtShape`). Taking the art away from it leaves an empty block
 * and nothing else, so "Remove ClikArt" deletes the object (WMPCM-13334).
 *
 * A ClikArt dropped into a shape the user drew is not standalone: that shape has a fill or a
 * stroke of its own, or text, so removing the art must keep it and only clear the fill.
 */
export function isStandaloneClikArtShape(shape: ShapeData): boolean {
  if (!resolvePlacedClikArtId(shape)) return false
  if (shape.kindId !== 1) return false

  const isInvisibleFill = shape.fill === 'transparent' || shape.fill === 'none' || !shape.fill
  const isInvisibleStroke =
    shape.stroke === 'transparent' || shape.stroke === 'none' || !shape.stroke || !shape.strokeWidth

  return isInvisibleFill && isInvisibleStroke && !shape.paragraphs?.length
}
